/* movimento.js — EZEED V3. JS puro, sem build, sem biblioteca. O CSS nativo faz o grosso; aqui só o que
   ele não faz: disparar uma vez ao entrar na tela, contar, digitar, pintar quadros no canvas e substituir
   animation-timeline onde não há. Tudo falha aberto: sem script, com erro ou sem canvas, o conteúdo aparece.

   ===== CONTRATO DE MARCAÇÃO (as seções da Etapa 3 seguem à letra) =====
   Carga: {% render 'movimento-inline' %} no <head>; <script src="movimento.js" defer onerror="…remove('js')"> no fim.
   <html> recebe do inline: .js (só com ela o CSS esconde algo), .css-scroll (animation-timeline nativo;
   sem ela o JS escreve as variáveis), .rm (reduced-motion, ao vivo: tudo no estado final), .rolou (scrollY > 24).
   Se este arquivo falhar (404 ou exceção), .js sai do <html> e a página fica inteira visível.

   REVELAR   <div data-rv style="--rv-passo:var(--passo); --rv-y:var(--rv-y-largo)"> <p class="rv" style="--i:0">…</p> </div>
     Dispara uma vez no trilho, nunca no item. Atraso = --i × --rv-passo (padrão --passo). Não aninhar.
     Duração: --rv-d no item (padrão --d-longa). movimento.css já dá --d-entrada a rótulo e linha
     fina e --d-cena a mídia e cartão: a revelação nunca tem uma duração só. --rv-y em três degraus
     (--rv-y-fino, --rv-y, --rv-y-largo); passo em --passo-fino/--passo/--passo-largo/--passo-cena.
     Trilho mais alto que a tela dispara ao entrar (texto do editor em .rte pode ter 12.000 px).
   PALAVRAS  <h1 data-split="words" style="--w-atraso:var(--atraso-gancho); --w-passo:var(--passo); --w-d:var(--d-longa)">Seu corpo.</h1>
     Vira .words > .w > span; pontuação gruda na anterior; <em> vira .w.acento; <br> sobrevive; <a> vira
     casca em volta das suas palavras (o link continua). <strong> e o resto entram como texto. Entra ao
     carregar; com data-auto="false" entra pelo observador.
   PREENCHER <h2 data-fill data-fill-ini="10" data-fill-faixa="60">O que mede, e o que <em>estima</em>.</h2>
     Vira .fill > .w com --i. ini = onde começa, faixa = quanto dura, em % da viagem pela tela.
     data-fill-range="cover|contain" (vale também no fallback). Dentro de .pin segue a timeline da cena.
   CONTAR    <span data-count data-alvo="3.5" data-dec="1" data-dur="1200">3,5</span>  (HTML traz o final)
     Grupo <div data-count-trilho> dispara os filhos juntos, de 120 em 120 ms. Sem data-dur vale --d-conta.
     Contador em trilho horizontal SEMPRE via data-count-trilho no trilho. Sempre JS.
   CENA      <section class="pin" data-frames="URL-da-pasta,62,webp" data-ajuste="contain|cover"
       data-desloca-x=".16" data-desloca-y="-.12" data-desloca-corte="820" data-fundo="--chao"
       style="--pin-altura:360svh; --pin-razao:16/9"> <div class="pin__stage"> <img class="pin__poster" …>
       <canvas class="pin__canvas" aria-hidden="true"></canvas> <div class="pin__cap" style="--i:0">…</div>
       <i data-pin-prog></i> </div> </section>
     Quadros q001…qNNN na pasta; em asset: {{ 'q001.webp' | asset_url | split: '/q001' | first }}. O pôster
     (mídia do editor) some quando o 1º quadro pinta. desloca-x vale acima do corte, desloca-y abaixo, em
     fração do canvas. data-fundo é nome de token. [data-pin-prog] recebe --pp (0 a 1).
     data-frames-lista='["url1","url2",…]' (JSON gerado pelo Liquid com asset_url, que tem hash por arquivo)
     substitui data-frames: a ordem da lista é a ordem dos quadros e o tamanho da lista é N.
     Sem data-frames (noite → dia da D6): só --pp e legendas; a imagem do dia usa opacity: var(--pp).
   DIGITAR   <p data-type data-text="Você dormiu bem." data-ms="42" data-atraso="0">Você dormiu bem.</p>
     Uma peça por página. Ganha .is-pronto no fim (o cursor ::after some).
   PARALLAX  <div class="para" style="--para-forca:6%"><img …></div>  (img ou video direto no .para)
   CHÃO      <section class="dawn" style="--dawn-de:var(--near-black); --dawn-para:var(--mineral)">
   VÍDEO     <video data-video-auto muted playsinline loop poster="…"> SEM autoplay. Toca ao entrar, pausa
     ao sair; se play() for recusado ou com .rm, fica o pôster (obrigatório).
   GANCHO    .is-in no trilho [data-rv] é público: uma seção pode pendurar nele uma transição local sua
     (barra que cresce até --v, fio que abre, traço de check), com duração e curva de tokens.css e o
     estado final em html.rm. É transição de CSS, sem JS novo: o observador é o mesmo do REVELAR.
   PROGRESSO LOCAL  arco ou barra amarrado à posição, fora da cena presa: timeline nativa sob
     @supports (animation-timeline: view()) e html.css-scroll, nomeada num elemento HTML com caixa
     (view-timeline: --nome; <circle> não gera caixa e view() direto nele não resolve); sem timeline,
     a transição pelo GANCHO; em html.rm, o estado final. Padrão de home-notas e home-conta.
   EDITOR    shopify:section:load monta só a seção nova.
   MEDIDOR   ?medir=1 → window.__medir.auto(px) rola e devolve quadros > 50 e > 16,7 ms; .report() lê.   ======================================================================= */
(function () {
  const html = document.documentElement;
  // falha aberta com JS: qualquer exceção devolve a página sem .js (o CSS só esconde sob html.js)
  try { corpo(); } catch (e) { html.classList.remove('js'); throw e; }

  function corpo() {
  // sem observador, vira a página sem JS
  if (!('IntersectionObserver' in window)) { html.classList.remove('js'); return; }
  const rm = () => html.classList.contains('rm');
  const cssScroll = html.classList.contains('css-scroll');
  const clamp = (v) => Math.max(0, Math.min(1, v));
  const fmt = (v, dec) => v.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  const busca = (raiz, sel) => (raiz.matches && raiz.matches(sel) ? [raiz] : []).concat(Array.from(raiz.querySelectorAll(sel)));
  const progPin = (r, vh) => { const total = r.height - vh; return total > 0 ? clamp(-r.top / total) : 1; };
  // a duração padrão do contador é token, não número solto
  const dConta = parseFloat(getComputedStyle(html).getPropertyValue('--d-conta')) || 900;

  // rolagem: um rAF só; leituras antes das escritas
  let tarefas = [], raf = 0;
  function rodar() { raf = 0; const vh = innerHeight; const lidos = tarefas.map((t) => t.ler(vh)); tarefas.forEach((t, i) => t.escrever(lidos[i])); }
  function agendar() { if (!raf) raf = requestAnimationFrame(rodar); }
  function amarrar(t) { if (!tarefas.length) { addEventListener('scroll', agendar, { passive: true }); addEventListener('resize', agendar); } tarefas.push(t); agendar(); }

  function splitWords(el, mascara) {
    const nos = Array.from(el.childNodes); el.textContent = ''; let i = 0;
    nos.forEach((n) => {
      const tag = n.nodeType === 1 ? n.tagName : '';
      if (tag === 'BR') { el.appendChild(document.createElement('br')); return; }
      // o link vira casca vazia em volta das suas palavras; só <em> é acento
      const pai = tag === 'A' ? el.appendChild(n.cloneNode(false)) : el;
      const acento = tag === 'EM';
      // o espaço rígido (&nbsp;) não separa palavra: a moeda anda junto com o valor
      n.textContent.split(/([^\S ]+)/).forEach((parte) => {
        if (!parte) return;
        if (/^[^\S ]+$/.test(parte)) { pai.appendChild(document.createTextNode(' ')); return; }
        const ant = pai.lastElementChild;
        // pontuação solta depois de um <em> cola na palavra anterior
        if (ant && ant.classList.contains('w') && /^[.,;:!?…)]+$/.test(parte)) { (mascara ? ant.firstElementChild : ant).textContent += parte; return; }
        const w = document.createElement('span'); w.className = 'w' + (acento ? ' acento' : ''); w.style.setProperty('--i', i++);
        if (mascara) { const s = document.createElement('span'); s.textContent = parte; w.appendChild(s); } else w.textContent = parte;
        pai.appendChild(w);
      });
    });
    return i;
  }

  function prepFill(el) {
    el.classList.add('fill');
    const n = splitWords(el, false) || 1, faixa = parseFloat(el.dataset.fillFaixa || '60'), ini = parseFloat(el.dataset.fillIni || '10'), passo = faixa / n;
    el.style.setProperty('--passo-fill', passo + '%'); el.style.setProperty('--fill-ini', ini + '%');
    if (el.dataset.fillRange) el.style.setProperty('--fill-range', el.dataset.fillRange);
    if (cssScroll) return;
    const ws = Array.from(el.querySelectorAll('.w')), fonte = el.closest('.pin'), contain = el.dataset.fillRange === 'contain';
    amarrar({ el, ler: (vh) => {
        const r = (fonte || el).getBoundingClientRect();
        if (fonte) return progPin(r, vh);
        // contain: de todo dentro até começar a sair; cover: de tocar embaixo até sair em cima
        return contain && r.height < vh ? clamp((vh - r.bottom) / (vh - r.height)) : clamp((vh - r.top) / (vh + r.height));
      },
      escrever: (p) => ws.forEach((w, i) => w.style.setProperty('--p', (100 - 100 * clamp((p * 100 - ini - i * passo) / passo)).toFixed(1) + '%')) });
  }

  // dispara por entrada: trilho mais alto que a tela nunca chega a 20% visível e ficaria invisível
  const entrou = (e) => e.isIntersecting && (e.intersectionRatio >= 0.2 || e.boundingClientRect.height > (e.rootBounds ? e.rootBounds.height : innerHeight));
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!entrou(e)) return; const t = e.target; io.unobserve(t);
    t.classList.add('is-in'); if (t.hasAttribute('data-type')) digitar(t);
  }), { threshold: [0, 0.2], rootMargin: '0px 0px -8% 0px' });
  // contadores sem margem no pé: barra no pé precisa contar
  const ioNum = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return; const t = e.target; ioNum.unobserve(t);
    busca(t, '[data-count]').forEach((d, i) => setTimeout(() => contar(d), i * 120));
  }), { threshold: 0.05 });
  const ioVideo = new IntersectionObserver((es) => es.forEach((e) => {
    const v = e.target; if (e.isIntersecting && !rm()) v.play().catch(() => {}); else v.pause();
  }), { threshold: 0.25 });

  function contar(el) {
    const alvo = parseFloat(el.dataset.alvo), dec = parseInt(el.dataset.dec || '0', 10), dur = el.dataset.dur ? parseFloat(el.dataset.dur) : dConta;
    if (isNaN(alvo)) return;
    if (rm() || !(dur > 0)) { el.textContent = fmt(alvo, dec); return; }
    const t0 = performance.now();
    const passo = (t) => { const k = Math.min(1, (t - t0) / dur); el.textContent = fmt((1 - Math.pow(1 - k, 3)) * alvo, dec); if (k < 1) requestAnimationFrame(passo); };
    requestAnimationFrame(passo);
  }

  function digitar(el) {
    const texto = el.dataset.text || '', ms = parseFloat(el.dataset.ms || '42');
    if (rm()) { el.textContent = texto; el.classList.add('is-pronto'); return; }
    let i = 0;
    const f = () => { el.textContent = texto.slice(0, ++i); if (i < texto.length) setTimeout(f, ms); else setTimeout(() => el.classList.add('is-pronto'), 700); };
    setTimeout(f, parseFloat(el.dataset.atraso || '0'));
  }

  // cena presa: quadros pedidos só quando a cena se aproxima; sem quadros, só progresso e legendas
  function prepPin(pin) {
    // lista explícita de URLs (asset_url tem hash por arquivo) ou pasta com q001…qNNN
    let lista = null; try { lista = pin.dataset.framesLista ? JSON.parse(pin.dataset.framesLista) : null; } catch (e) { lista = null; }
    const partes = (pin.dataset.frames || '').split(','), N = lista ? lista.length : parseInt(partes[1], 10) || 0, pasta = (partes[0] || '').trim().replace(/\/$/, ''), ext = (partes[2] || 'webp').trim();
    const canvas = pin.querySelector('.pin__canvas'), ctx = N > 0 && canvas && canvas.getContext && canvas.getContext('2d');
    const prog = pin.querySelector('[data-pin-prog]'), caps = Array.from(pin.querySelectorAll('.pin__cap'));
    pin.style.setProperty('--cap-fatia', (100 / Math.max(1, caps.length)) + '%');
    // fundo por nome de token: a cor mora em tokens.css
    let fundo = pin.dataset.fundo || ''; if (fundo.indexOf('--') === 0) fundo = getComputedStyle(pin).getPropertyValue(fundo).trim();
    const quadros = []; let cur = -1, quer = 0, pedidos = false;
    function pedir(i) { if (quadros[i]) return; const im = new Image(); im.decoding = 'async'; im.src = lista ? lista[i] : pasta + '/q' + String(i + 1).padStart(3, '0') + '.' + ext; im.onload = () => { if (quer === i) desenhar(i); }; quadros[i] = im; }
    function pedirEmOndas() {
      pedir(0);
      const passo = 8, fila = [];
      for (let i = passo; i < N; i += passo) fila.push(i);
      for (let i = 1; i < N; i++) if (i % passo) fila.push(i);
      let n = 0;
      const proximo = () => { if (n >= fila.length) return; pedir(fila[n++]); setTimeout(proximo, 0); };
      // duas frentes: a grade grossa chega antes e a cena ja anda, o resto preenche depois
      proximo(); proximo();
    }
    function desenhar(idx) {
      idx = Math.max(0, Math.min(N - 1, idx)); quer = idx; if (idx === cur) return;
      const im = quadros[idx]; if (!im || !im.complete || !im.naturalWidth) { pedir(idx); return; }
      cur = idx;
      const cw = canvas.width, ch = canvas.height, iw = im.naturalWidth, ih = im.naturalHeight, largo = innerWidth > parseFloat(pin.dataset.deslocaCorte || '820');
      const s = pin.dataset.ajuste === 'contain' ? Math.min(cw / iw, ch / ih) : Math.max(cw / iw, ch / ih), dw = iw * s, dh = ih * s;
      const ox = largo ? parseFloat(pin.dataset.deslocaX || '0') * cw : 0, oy = largo ? 0 : parseFloat(pin.dataset.deslocaY || '0') * ch;
      ctx.clearRect(0, 0, cw, ch); if (fundo) { ctx.fillStyle = fundo; ctx.fillRect(0, 0, cw, ch); }
      ctx.drawImage(im, (cw - dw) / 2 + ox, (ch - dh) / 2 + oy, dw, dh); pin.classList.add('is-pronta');
    }
    // a medida do canvas entra na mesma tarefa (leitura em ler, escrita em escrever) e morre com ela
    amarrar({ el: pin,
      ler: (vh) => {
        const r = pin.getBoundingClientRect(), p = rm() ? 1 : progPin(r, vh);
        // por prioridade, nao em rajada: 62 pedidos simultaneos disputavam a banda com o resto
        // da pagina. Primeiro o quadro 1, depois de 8 em 8 (a cena ja roda), depois o resto.
        if (ctx && !pedidos && !rm() && r.top < vh * 2) { pedidos = true; pedirEmOndas(); }
        if (!ctx) return { p };
        const c = canvas.getBoundingClientRect(), dpr = Math.min(2, devicePixelRatio || 1);
        return { p, cw: Math.round(c.width * dpr), ch: Math.round(c.height * dpr) };
      },
      escrever: (m) => {
        if (ctx) {
          if (canvas.width !== m.cw || canvas.height !== m.ch) { canvas.width = m.cw; canvas.height = m.ch; cur = -1; }
          desenhar(Math.round(m.p * (N - 1)));
        }
        if (prog) prog.style.setProperty('--pp', m.p.toFixed(3));
        if (cssScroll || rm()) return;
        // legendas na curva dos keyframes cap (22% entra, 22% sai)
        caps.forEach((c, i) => { const k = (m.p - i / caps.length) * caps.length; let o = 0, y = 16;
          if (k >= 0 && k < 1) { o = k < .22 ? k / .22 : k > .78 ? (1 - k) / .22 : 1; y = k < .22 ? 16 - 16 * k / .22 : k > .78 ? -16 * (k - .78) / .22 : 0; }
          c.style.opacity = o.toFixed(3); c.style.transform = 'translateY(' + y.toFixed(1) + 'px)'; });
      } });
  }

  // sem animation-timeline: parallax e chão escrevem a variável que o CSS consome
  function prepPara(m) { amarrar({ el: m, ler: (vh) => { const r = m.parentElement.getBoundingClientRect(); return clamp((vh - r.top) / (vh + r.height)); }, escrever: (p) => m.style.setProperty('--para-p', p.toFixed(3)) }); }
  function prepDawn(el) { amarrar({ el, ler: (vh) => { const r = el.getBoundingClientRect(); return clamp((vh - r.top) / (vh + r.height) / .6); }, escrever: (p) => el.style.setProperty('--dawn-p', p.toFixed(3)) }); }

  function montar(raiz) {
    busca(raiz, '[data-split="words"]').forEach((el) => { el.classList.add('words'); splitWords(el, true); if (el.dataset.auto === 'false') io.observe(el); else requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in'))); });
    busca(raiz, '[data-fill]').forEach(prepFill);
    busca(raiz, '[data-count]').forEach((el) => { el.textContent = fmt(rm() ? parseFloat(el.dataset.alvo) || 0 : 0, parseInt(el.dataset.dec || '0', 10)); if (!el.closest('[data-count-trilho]')) ioNum.observe(el); });
    busca(raiz, '[data-count-trilho]').forEach((el) => ioNum.observe(el));
    busca(raiz, '[data-type]').forEach((el) => { if (!el.dataset.text) el.dataset.text = el.textContent.trim();
      // o texto sai do DOM ate a digitacao terminar: sem o aria-label a peca fica muda
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.dataset.text);
      if (!rm()) el.textContent = ''; io.observe(el); });
    busca(raiz, '[data-rv]').forEach((el) => io.observe(el));
    busca(raiz, '[data-video-auto]').forEach((v) => ioVideo.observe(v));
    busca(raiz, '.pin').forEach(prepPin);
    if (!cssScroll && !rm()) { busca(raiz, '.para > img, .para > video').forEach(prepPara); busca(raiz, '.dawn').forEach(prepDawn); }
  }
  montar(document);
  // editor da Shopify: a seção recarregada chega nova; as tarefas da antiga saem
  document.addEventListener('shopify:section:load', (e) => montar(e.target));
  document.addEventListener('shopify:section:unload', () => { tarefas = tarefas.filter((t) => t.el.isConnected); });

  // medidor (?medir=1): engasgos só enquanto rola, como no lab
  if (/[?&]medir=1(&|$)/.test(location.search)) {
    const m = { frames: 0, long50: 0, mid16: 0, worst: 0, last: 0, rolando: false, t: 0 };
    const tick = (t) => { if (m.last && m.rolando) { const d = t - m.last; m.frames++; if (d > 50) m.long50++; if (d > 16.7) m.mid16++; if (d > m.worst) m.worst = Math.round(d); if (t - m.t > 150) m.rolando = false; } m.last = t; requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
    addEventListener('scroll', () => { m.rolando = true; m.t = performance.now(); }, { passive: true });
    const report = () => Object.assign({ w: innerWidth, cssScroll, rm: rm(), lateral: html.scrollWidth > innerWidth }, m);
    window.__medir = { report, auto: (px) => new Promise((res) => {
      scrollTo(0, 0); Object.assign(m, { frames: 0, long50: 0, mid16: 0, worst: 0 });
      const max = html.scrollHeight - innerHeight, passo = px || (innerWidth < 500 ? 10 : 14);
      const step = () => { const y = Math.min(max, scrollY + passo); scrollTo(0, y); m.rolando = true; m.t = performance.now(); if (y < max) requestAnimationFrame(step); else setTimeout(() => res(report()), 200); };
      requestAnimationFrame(step);
    }) };
  }
  }
})();
